module.exports = __webpack_public_path__ + "img/gh_d69bc3248743_258.983b9059.jpg";